$(document).ready(function () {

	const retailListing = {
		setup: function (element) {
			this.element = element;
			this.setupTabs();
			this.setupFilters();
			this.setupCardLinks();
			this.scrollToRetailListItem();
		},
		getTabs: function () {
			return this.element.querySelectorAll('.js--tab-link');
		},
		getCurrentTab: function () {
			let currentTab = 'shopping';
			const tabs = this.getTabs();
			for (let i = 0; i < tabs.length; i++) {
				const tab = tabs[i];
				if (tab.classList.contains('active')) {
					currentTab = tab.dataset.tab;
				}
			}

			return currentTab;
		},
		getCurrentCategoryFilter: function () {
			return this.element.querySelector('[data-category-filter="' + this.getCurrentTab() + '"]');
		},
		getCurrentNameFilter: function () {
			return this.element.querySelector('[data-name-filter="' + this.getCurrentTab() + '"]');
		},
		getCategoryFilters: function () {
			return this.element.querySelectorAll('[data-category-filter]');
		},
		getNameFilters: function () {
			return this.element.querySelectorAll('[data-name-filter]');
		},
		getCards: function () {
			return this.element.querySelectorAll('.retailListing--card__wrap');
		},
		getCardLinks: function () {
			return this.element.querySelectorAll('.retailListing--card a');
		},
		getNoResultsBlock: function () {
			return this.element.querySelector('.retailListing__no-results');
		},
		getClearFiltersLink: function () {
			return document.getElementById('clearFilters');
		},
		setupTabs: function () {
			const _this = this;
			$(this.getTabs()).on('click',
				function () {
					_this.setListMode(this.dataset.tab);
				});
			this.setListMode(getUrlParameter('listmode'));
		},
		setupFilters: function () {
			const _this = this;
			$(this.getCategoryFilters()).on('change', function() { _this.doFilter(); });
			$(this.getNameFilters()).on('keyup', function () { _this.doFilter(); });
			this.clearFilters();
			$(this.getClearFiltersLink()).on('click', function () { _this.clearFilters(); });

			const category = this.getUrlParameter('category');
			if (category) {
				this.getCurrentCategoryFilter().value = category;
				this.getCurrentCategoryFilter().dispatchEvent(new Event('change'));
			}

			const name = this.getUrlParameter('name');
			if (name) {
				this.getCurrentNameFilter().value = name;
			}

			this.doFilter();
		},
		setupCardLinks: function () {
			const _this = this;
			const cardLinks = this.getCardLinks();
			for (let i = 0; i < cardLinks.length; i++) {
				const cardLink = cardLinks[i];
				cardLink.addEventListener('click',
					function(evt) {
						const card = $(evt.target).closest('.retailListing--card').parent(),
							listMode = _this.getUrlParameter('listmode'),
							shopId = card.data('shopid'),
							category = _this.getCurrentCategoryFilter().value,
							name = _this.getCurrentNameFilter().value;
						_this.setUrlForBackButton(listMode, shopId, category, name);
					});
			}
		},
		setListMode: function (listMode) {
			if (!listMode)
				listMode = 'shopping';

			this.setUrlForBackButton(listMode, this.getUrlParameter('shopid'), this.getUrlParameter('category'), this.getUrlParameter('name'));
			this.openTab(listMode);
			this.clearFilters();
		},
		setUrlForBackButton: function (listMode, shopId, category, name) {
			let url = window.location;

			url = this.setUrlParameter(url, 'listmode', listMode);
			url = this.setUrlParameter(url, 'shopid', shopId);
			url = this.setUrlParameter(url, 'category', category);
			url = this.setUrlParameter(url, 'name', name);

			window.history.pushState(null, null, url);
		},
		clearFilters: function () {
			$('[data-dropdown-value="Clear filters"]').trigger('click');

			const categoryFilters = this.getCategoryFilters();
			for (let i = 0; i < categoryFilters.length; i++) {
				categoryFilters[i].selectedIndex = 0;
			}

			const nameFilters = this.getNameFilters();
			for (let i = 0; i < nameFilters.length; i++) {
				nameFilters[i].value = '';
			}

			this.doFilter();
		},
		doFilter: function () {
			const categoryFilter = this.getCurrentCategoryFilter(),
				category = categoryFilter.value,
				nameFilter = this.getCurrentNameFilter(),
				nameQuery = nameFilter.value.toUpperCase();

			let noResults = true;
			const cards = this.getCards();
			for (let i = 0; i < cards.length; i++) {
				const card = cards[i];
				if ((!category || card.dataset.category.split(';').indexOf(category) >= 0) &&
					(!nameQuery || card.dataset.shopname.toUpperCase().includes(nameQuery))) {
					noResults = false;
					card.classList.add('active');
				} else {
					card.classList.remove('active');
				}
			}

			this.getNoResultsBlock().classList.toggle('active', noResults && (category || nameQuery));
		},
		openTab: function (tabName) {
			if (!tabName)
				return;

			const tabContents = document.querySelectorAll('[data-tab-content]');
			for (let i = 0; i < tabContents.length; i++) {
				const tabContent = tabContents[i];
				tabContent.classList.toggle('active', tabContent.dataset.tabContent === tabName);
			}

			const tabs = document.querySelectorAll('[data-tab]');
			for (let i = 0; i < tabs.length; i++) {
				const tab = tabs[i];
				tab.classList.toggle('retailListing--sections__selected', tab.dataset.tab === tabName);
				tab.classList.toggle('active', tab.dataset.tab === tabName);
			}
		},
		scrollToRetailListItem: function () {
			const shopId = this.getUrlParameter('shopid');
			if (shopId) {
				$('html, body').animate({
					scrollTop: $('.retailListing--card__wrap[data-shopid="' + shopId + '"]').offset().top - $('header').outerHeight()
				}, 2000);
			}
		},
		getUrlParameter: function (param) {
			const url = new URL(window.location);
			return url.searchParams.get(param);
		},
		setUrlParameter: function (urlString, param, value) {
			if (!urlString)
				urlString = window.location;
			const url = new URL(urlString);
			if (value)
				url.searchParams.set(param, value);
			else
				url.searchParams.delete(param);
			return url.toString();
		}
	};

	const retailListingElement = document.querySelector('.retailListing');
	if (retailListingElement)
		retailListing.setup(retailListingElement);

	const closeButton = document.querySelector('.close-button');
	if (closeButton)
		closeButton.addEventListener('click', closeModal);

	window.addEventListener('click', windowOnClick);
});

// *************** MODAL ***************
function toggleModal(ev) {
	const modalImage = document.querySelector('.modal-image'),
		modal = document.querySelector('.modal'),
		modalLink = document.querySelector('.modal-link');

	modalImage.src = ev.target.attributes['data-image'].value;
	modalImage.style.display = 'block';
	modalLink.href = ev.target.attributes['data-link'].value;
	modal.classList.toggle('show-modal');
}

function closeModal() {
	const modal = document.querySelector('.modal');
	modal.classList.remove('show-modal');
}

function windowOnClick(event) {
	const modal = document.querySelector('.modal');
	if (event.target === modal) {
		toggleModal(event);
	}
}

function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
	return '';
};